import { rem } from '@mantine/core'

/** Fixed width of the desktop refinement rail; parent must use the same value for `paddingRight` so content clears the panel. */
export const REFINEMENT_RAIL_WIDTH = rem(420)

/**
 * Stack order for Q&A / AI refinement surfaces (rail + bottom drawer).
 * Must stay above `NotificationContainer` (z-index 700) so “Plan updated” toasts
 * do not cover personalization controls.
 */
export const REFINEMENT_SURFACE_Z_INDEX = 750
